import React from 'react';
 
import BoxMenu from "../box-menu/box-menu";
 
interface BoxMenuItemProps {
  boxSize: { height: string, width: string };
  disabled: boolean;
  icon: string;
  iconSize: string;
  title: any;
  titleFontSize: string;
  onBoxClick: () => void;
}
 
const BoxMenuItem: React.FC<BoxMenuItemProps> = ({ disabled, boxSize, icon, iconSize, title, titleFontSize, onBoxClick }) => (
  <BoxMenu
    boxHeight={boxSize.height}
    boxWidth={boxSize.width}
    icon={icon}
    iconSize={iconSize}
    title={title}
    titleFontSize={titleFontSize}
    onBoxClick={onBoxClick}
    disabled={disabled}
  />
);
 
export default BoxMenuItem;